module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Patricia Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("1. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEXPLAINABLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("Welcome to Staaten Eylandt: An Accidental Discovery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMESTEADS")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANSIONS AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIDENTIAL")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Billopp House, Also Known as the Conference House")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Billou-Stillwell-Perine House")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biddle House")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kreischler Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historic Old Bermuda Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alice Austen House, Also Known as Clear Comfort ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Garibaldi-Meucci Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Portrait")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHMOND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWN")]), _vm._v(": S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NUG")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARBOR")]), _vm._v(", R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OADS")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDMARKS AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDUSTRIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailors’ Snug Harbor")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Matron’s Cottage")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Music Hall")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richmond Town")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Guyon-Lake-Tysen House")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Voorlezer’s House and Rezeau–Van Pelt Cemetery")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Parsonage")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bard and Hendeson Avenue Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69 Delafield Place")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petticoat Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shipyards")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-6-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bethlehem Steel")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSPITALS AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NSTITUTIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seaview Hospital and New York Farm Colony")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wagner College, Cunard Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saint John’s University, Flynn Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willowbrook State School")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saint George Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ghost Lights: What Is the Superstition of the Ghost Light?")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fort Wadsworth")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMETERIES")]), _vm._v(", D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCKS AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moravian Cemetery and the Vanderbilt Family Cemetery and Mausoleum")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baron Hirsch Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Andrew’s Church, Graveyard and Parish Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Lane Cemetery: Speaking for the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rezeau–Van Pelt Graveyard")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staten Island Boat Graveyard")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Kills Landfill")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKES AND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IELDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miller Field")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLKTALES")]), _vm._v(", U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RBAN")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDS")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YTHS AND")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OAXES")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cropsey")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Staten Island Monastery, Augustinian Academy")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backseat Killer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phantom Dog on Victory Boulevard: “Beware the Signs”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Witch of Staten Island")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dollhouse Heist")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lady in White")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staten Island’s Most Compelling Mystery of 1963")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghostly Hitchhiker")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantom Joggers of Wolfe’s Pond Park")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Real Ichabod Crane")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aaron Burr’s Restless Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0